import React from 'react'
import { domToReact, Element } from 'html-react-parser'
import BaseRichTextComponent from './BaseRichTextComponent'
import RichTextComponentTypes from './RichTextComponent.types'
import CustomLinkComponent from '@atoms/CustomLink/CustomLinkComponent'

class RichTextComponent extends BaseRichTextComponent {
  constructor(props: RichTextComponentTypes) {
    super(props)
  }

  handleLinkTag(element: Element) {
    const { href = '', target } = element.attribs

    return (
      <CustomLinkComponent
        href={href}
        inline={true}
        className='break-all underline underline-offset-2'
        isExternalLink={href.indexOf('http') > -1}
        openInNewTab={target === '_blank'}
        uppercase={false}
      >
        {domToReact(element.children, {})}
      </CustomLinkComponent>
    )
  }
}

export default RichTextComponent
